export const smWidth = 575;

export const mdWidth = 758;

export const lgWidth = 992;

export const xlWidth = 1200;